export function deleteKey(event) {
  event.preventDefault()

  const activeType = this.state.activeType
  if (activeType === 'backdrop' && this.backdropItem) {
    this.backdropItem.remove()
    this.backdropItem = null
  } else if (activeType === 'resize' && this.resizingItem) {
    this.resizingItem.remove()
    this.resizingItem = null
  } else if (
    ['filledRectang', 'filledLine', 'filledArrow', 'text'].includes(activeType) &&
    this.selectedItem
  ) {
    this.selectedItem.remove()
    this.selectedItem = null
  }
  this.engine.reRender()

  return
}



// WEBPACK FOOTER //
// ./src/components/ScreenshotEditor/keyboardActions/deleteKey.js